module.exports = __webpack_public_path__ + "img/BACKGROUND_ECO_EMP_SMALL.cd220689.jpg";